import { render } from "./HomeView.vue?vue&type=template&id=33a6e39d&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "@/assets/about.css?vue&type=style&index=0&id=33a6e39d&lang=css&scoped=true"
import "@/assets/nicepage.css?vue&type=style&index=1&id=33a6e39d&lang=css&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a6e39d"]])

export default __exports__